class exports.ValidationEngine
    constructor: () ->
        @forms = []
        @rules = []
        @gbl_callback = null
        @validating = true

        # This is only ever used temporarily to make sure invalid inputs are
        # highlighted correctly. The reason it is attached to `this` is so that
        # it can be easily used across multiple methods without passing another
        # parameter (which would get really messy). Just make sure to reset it
        # as needed.
        # -SK
        @invalidInputs = []

        @event =
            'change.mfvalidate': @revalidateEvent


        # pre-register a bunch of commonly used rules

        @registerRule
            selector: '.validate-required',
            text: '%s is required',
            func: (elem) ->
                val = elem.val()
                return !!val and val isnt 'undefined'

        @registerRule
            selector: '.validate-date',
            text: '%s must be a valid date',
            func: (elem) ->
                val = elem.val()
                # may want to use a regex to force a particular date format
                return not val or !!Date.parse(val)

        # turns out this is never used... if you want it, just uncomment it
        # @registerRule
        #     selector: '.validate-notInPast',
        #     text: '%s cannot be in the past',
        #     func: (elem) ->
        #         val = elem.val()
        #         return not val or Date.parse(val) > Date.parse(Date().toString())

        @registerRule
            selector: '.validate-email'
            text: 'The email address you entered is not properly formatted'
            func: (elem) ->
                return $(elem).val().length is 0 or $(elem).val().match(/^[\w._%+-]+@[\w.-]+\.[A-za-z]{2,6}$/)

        @registerRule
            selector: '.validate-tags-required',
            text: '%s is required',
            func: (elem) ->
                # select2 applies the input classes to the created div this cause double validation.
                # I chose to ignore the input and use the div to allow the error css to work
                if elem.is('div') and elem.hasClass('select2-container')
                    return elem.find('.select2-search-choice').length > 0
                else
                    return true

        @registerRule
            selector: '.validate-hasOptions'
            text: '%s must be populated'
            func: (elem) ->
                options = $(elem).find('option')
                return options.length > 0

        @registerRule
            selector: '.validate-isPositive',
            text: '%s must be greater than 0',
            func: (elem) ->
                val = elem.val()
                return (not val or ($.isNumeric(val) and parseFloat(val) > 0) )

        @registerRule
            selector: '.validate-notLessThanZero',
            text: '%s cannot be less than 0',
            func: (elem) ->
                val = elem.val()
                return (not val or ($.isNumeric(val) and parseFloat(val) >= 0) )

        @registerRule
            selector: '.validate-isNumeric',
            text: '%s must be a numeric value',
            func: (elem) ->
                val = elem.val()
                return not val or $.isNumeric(val)

        @registerRule
            selector: '.validate-isInteger',
            text: '%s must be a whole number',
            func: (elem) ->
                val = elem.val()
                return not val or ( $.isNumeric(val) and val % 1 is 0 )

        @registerRule
            selector: '.validate-required-if-enabled'
            text: '%s is required'
            func: (elem) ->
                return true if elem.is('[disabled]')

                val = elem.val()
                return !!val and val isnt 'undefined'

        @registerRule
            selector: '.validate-required-if-visible'
            text: '%s is required'
            func: (elem) ->
                return true if not elem.is(':visible')

                val = elem.val()
                return !!val and val isnt 'undefined'

        @registerRule
            selector: '.validate-max'
            text: (elem, name) ->
                return "#{name} cannot have more than #{elem.data('max')} characters"
            func: (elem) ->
                max = elem.data('max')
                return elem.val().length <= max

        @registerRule
            selector: '.validate-min'
            text: (elem, name) ->
                return "#{name} cannot have fewer than #{elem.data('min')} characters"
            func: (elem) ->
                min = elem.data('min')
                return elem.val().length >= min

        @registerRule
            selector: '.validate-select2-required',
            text: '%s is required',
            func: (elem) ->
                # select2 applies the input classes to the created div, which causes double validation.
                # To get around this, I just check that the element is an input (as opposed to a div).
                if elem.is('input')
                    val = elem.val()
                    return !!val and val isnt 'undefined'
                else
                    return true


    registerRule: (obj) ->
        @rules[obj.selector] = obj

        for name, form of @forms
            form.selector.on @event, "#{obj.selector}"


    makeFormValidator: (name, selector, errorDiv, callback) ->
        if selector not instanceof jQuery
            selector = $(selector)

        if errorDiv not instanceof jQuery
            errorDiv = $(errorDiv)

        @forms[name] =
            'selector': selector
            'errorDiv': errorDiv
            'func': callback

        errorDiv.message_writer
            autohide: false

        for cls, obj of @rules
            selector.on @event, "#{cls}"


    setCallback: (callback) ->
        @gbl_callback = callback


    clearErrors: () ->
        for name, form of @forms
            errorDiv = form.errorDiv
            errorDiv.empty().message_writer('hide', 0) if errorDiv.length


    revalidateEvent: (e) =>
        @revalidateInput(e.target)


    revalidateInput: (elem) =>
        return if not @validating

        elem = $(elem) if elem not instanceof jQuery

        @invalidInputs = []
        for name, form of @forms
            if elem.closest(form.selector).length isnt 0
                for cls, rule of @rules

                    if rule.group? and elem.data(rule.group.attr)?
                        attr = elem.data(rule.group.attr)
                        elems = form.selector.find("#{cls}[data-#{rule.group.attr}='#{attr}']")
                        @validateInput(elems, cls, form, attr)

                    else if elem.is cls
                        @validateInput(elem, cls, form)


    validateUnconditionally: () ->
        for name, form of @forms
            form.func(true)


    validateAll: (callFunc = true) ->
        return if not @validating
        for name, form of @forms
            @validateForm name, callFunc


    validateForm: (name, callFunc = true) ->
        return if not @validating
        form = @forms[name]
        return if not form.selector.length

        form.deferred = $.when()

        valid = true
        @invalidInputs = []
        for cls, rule of @rules
            groups = []

            # Validate each element
            for elem in form.selector.find(cls)
                elem = $(elem)

                # Defer validation of groups until later
                if rule.group? and elem.data(rule.group.attr)?
                    attr = elem.data(rule.group.attr)
                    groups[attr] = $() if not groups[attr]?
                    groups[attr] = groups[attr].add elem
                else
                    valid = false if not @validateInput(elem, cls, form)

            # Validate the groups
            for attr, group of groups
                valid = false if not @validateInput(group, cls, form, attr)

        # wait for the deferred to be done
        form.deferred.always () ->
            form.func(valid and form.deferred.state() is 'resolved') if callFunc

        return valid


    validateInput: (elem, cls, form, attr = null) ->
        return if not @validating

        rule = @rules[cls]
        if rule.ajax

            # Make the ajax request
            ajax = $.post rule.ajax.url, rule.ajax.data(elem)

            # Handle failure of the ajax request
            ajax.fail () =>
                @handleValidationResult elem, rule, form.errorDiv, false, attr

            # Convert the result of the ajax request to a rejected deferred if it failed
            ajax = ajax.then (response) =>
                if rule.func(response)
                    @handleValidationResult elem, rule, form.errorDiv, true, attr
                    return response
                else
                    @handleValidationResult elem, rule, form.errorDiv, false, attr
                    return $.Deferred().reject(response)

            # I do not know why this is necessary, but we must attach a fail() handler
            # in case the deferred is rejected by the above line
            # Also, we MUST reassign ajax above, but we don't need to reassign it here.
            # This makes absolutely zero sense.
            ajax.then (response) =>
                response
            , (response) =>
                response

            # Add the ajax to the when for this form
            form.deferred = $.when(form.deferred, ajax)
            return true

        else
            return @handleValidationResult elem, rule, form.errorDiv, rule.func(elem), attr


    handleValidationResult: (elem, rule, errorDiv, returnStatus, attr = null) ->
        return if elem.length is 0

        if rule.group? and elem.length > 1
            name = rule.group.name
            name = @getInputName elem if not name?
            name = name.replace '%g', attr if attr
        else
            name = @getInputName elem

        name = name.replace /'/g, ''

        if returnStatus
            # unhighlight if not already in the list of invalid inputs

            # todo: convert this to use the php.js in_array() function
            invalid = false

            elem.each (i, domEl) =>
                for el in @invalidInputs
                    if el is domEl
                        invalid = true
                        break
                if invalid then return false

            if not invalid
                elem.removeClass "mfvalidate-invalid-#{rule.selector}"

            # remove error message
            errorDiv.find("p[data-error-cls='#{rule.selector}'][data-error-name='#{name}']").remove()
            if errorDiv.has('p[data-error-cls][data-error-name]').length is 0 and $.contains(document, errorDiv[0])
                errorDiv.message_writer('clear')
            else if $.contains(document, errorDiv[0])
                errorDiv.message_writer('show')

        else
            # highlight
            elem.addClass "mfvalidate-invalid-#{rule.selector}"

            # add error message
            if typeof rule.text is 'function'
                text = rule.text(elem, name)
            else
                text = rule.text.replace '%s', name

            pTag = errorDiv.find("p[data-error-cls='#{rule.selector}'][data-error-name='#{name}']")
            if pTag.length is 0
                errorDiv.append("<p data-error-cls='#{rule.selector}' data-error-name='#{name}'>#{text}</p>")
            else
                pTag.html text
            if $.contains(document, errorDiv[0])
                errorDiv.message_writer('show')

            # add to the list of invalid inputs
            elem.each (i, domEl) =>
                @invalidInputs.push domEl


        return returnStatus


    getInputName: (input) ->
        input = $(input) if input not instanceof jQuery

        name = input.data('validation-name')
        return name if name

        name = $("label[for='#{input.attr('id')}']")
        return name.text().replace(/:|\s*\*\s*/g, '') if name.length

        name = input.attr('name')
        if name? and name.replace?
            return name.replace(/_|-/g, ' ').replace /\w\S*/g, (txt) ->
                txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()

        return 'Input'


    isValidating: =>
        return @validating

    stopValidating: =>
        @validating = false

    startValidating: =>
        @validating = true


# can pass in multiple forms, each with own callback
# callback for entire thing
# validate input on blur/change
# don't have to put validationContainer explicity in the DOM...just inputs and errorDiv

# validate groups of inputs rather than single elements
# associate element/group with error text for better removal of error messages
# option to display multiple error messages per input or not
# specify different errorDiv per form
